import React from 'react';
import { Typography } from '@axtria/design-system-react';
import { NotificationRecord } from './NotificationTypes';
import {
  getAvatarColor,
  getHeading,
  getInitials,
  getPrimaryText,
  getRelativeTime,
  getResourceName,
  getResourceType,
  getSenderName,
} from './NotificationUtils';

interface NotificationRowProps {
  item: NotificationRecord;
  onSelect: (_item: NotificationRecord) => void;
}

const NotificationRow: React.FC<NotificationRowProps> = ({ item, onSelect }) => {
  const resourceType = getResourceType(item);
  const senderName = getSenderName(item);

  return (
    <div
      className='notification-item'
      title={getResourceName(item)}
      onClick={() => onSelect(item)}
    >
      <span
        className='notification-avatar'
        style={{ backgroundColor: getAvatarColor(senderName) }}
      >
        {getInitials(senderName)}
      </span>
      <div className='notification-body'>
        <Typography level="ui" levelVariant="medium500" textColor="grey.70">
          {getHeading(item)}
        </Typography>
        <Typography level="ui" levelVariant="small400" textColor="grey.60" className="notification-artifact-text">
          {getPrimaryText(item)}
          {resourceType && (
            <Typography level="ui" levelVariant="small400" textColor="grey.40">
              {` · ${resourceType}`}
            </Typography>
          )}
        </Typography>
        <Typography  level="ui" levelVariant="small400" textColor="grey.40">
          {getRelativeTime(item.created_at)}
        </Typography>
      </div>
      {!item.is_read && <span className='notification-unread-dot' />}
    </div>
  );
};

export default NotificationRow;
